import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ErrorMessageModel} from '../../../../models/typeform/error-message.model';

@Component({
  selector: 'app-typeform-error-message',
  templateUrl: './typeform-error-message.component.html',
  styleUrls: ['./typeform-error-message.component.less']
})
export class TypeformErrorMessageComponent implements OnInit {

  column: string;
  isDesc = false;

  @Input() errorMessageList: ErrorMessageModel[];

  @Output() closePanel: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  sort(by: string) {

  }

  close() {
    this.closePanel.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/typeform/typeform-error-message/typeform-error-message.component.ts